export default __webpack_public_path__ + "static/media/Email- Link.56bb2123.png";